const getFullName = (surname, name, middleName) => (`${surname} ${name} ${middleName}`)

export default getFullName
